import invoke from '@hc-frontend/shared-assets/src/js/utils/fp/invoke'
import querySelectorAll from 'utils/DOM/querySelectorAll'

function loadFromElems(selector = '.trustpilot-widget') {
  const elems = querySelectorAll(selector)
  const elemsArr = [...elems]

  elemsArr.forEach(elem => {
    window.Trustpilot &&
      invoke(window.Trustpilot.loadFromElement).bind(window.Trustpilot)(elem)
  })
}

export default loadFromElems
